import { FaSearch } from "react-icons/fa";

const InputCatalogoCuentas = ({
  valor,
  onClick,
  placeholder = "",
  nombreCuenta
}) => {
  const cuentaNombre = nombreCuenta || placeholder;

  return (
    <button
      type="button"
      onClick={() => onClick(valor)}
      className="w-full flex items-center justify-between p-2 rounded-xl text-gray-700 border border-gray-400 bg-white hover:border-verde-oscuro transition-colors"
    >
      <span className="truncate text-left">{cuentaNombre}</span>
      <FaSearch className="text-verde-claro ml-2" />
    </button>
  );
};

export default InputCatalogoCuentas;